import React, { memo } from 'react';
import { isTruthy } from 'utility/functions';
import { useInfoTipoScommessaInformation } from 'features/sport/hooks';

import { ScommesseTableTitle } from 'components/scommesseTable/scommesseTableTitle';
import { SportTableScommesse } from 'features/sport/components/sportTableScommesse';
import { SportsPiuGiocateContentTabDto, SportsPointerAvvenimentoDto } from 'types/swagger';
import { TooltipPosition } from 'components/tooltip';
import classNames from 'classnames';
import { isHappybetSite } from 'utility/constant';
import styles from '../LiveInEvidenza.module.scss';
import { shallowEqual } from 'fast-equals';
import useWindowSize from 'hooks/useWindowSize';

export interface ManifestationeContentPropsType {
  isFirst: boolean;
  avvenimenti: Array<SportsPointerAvvenimentoDto>;
  manifestazione: SportsPiuGiocateContentTabDto;
  isNotTopTemplate?: boolean;
  indexManifestazione: number;
  infoTipoScommessaIndex: number;
  infoTipoScommesseKeyListTab: Array<string>;
}

export const ManifestationeContent = memo(
  function ManifestationeContent({
    isFirst,
    avvenimenti,
    manifestazione,
    isNotTopTemplate,
    indexManifestazione,
    infoTipoScommessaIndex,
    infoTipoScommesseKeyListTab,
  }: ManifestationeContentPropsType) {
    const {
      iconSrc,
      gruppo: labelSxGruppo,
      gruppoTrKey: labelSxGruppoTrKey,
      descrizione: labelSx,
      descrizioneTrKey: labelSxTrKey,
    } = manifestazione ?? {};
    const { isMobile } = useWindowSize();

    const { infoTipoScommessaList, infoTipoScommessaKeyList, infoTipoScommessaDescription } =
      useInfoTipoScommessaInformation(infoTipoScommesseKeyListTab);
    const { descrizione: labelDx, descrizioneTrKey: labelDxTrKey } =
      infoTipoScommessaDescription?.[infoTipoScommessaIndex] ?? {};

    return (
      <div className={classNames(styles.wrapperIsVisible, { [styles.noMargin]: isTruthy(isFirst) })}>
        <ScommesseTableTitle
          labelSx={isNotTopTemplate ? '' : labelSx}
          preLabelSx={isNotTopTemplate || !isHappybetSite ? '' : labelSxGruppo}
          labelSxTrKey={isNotTopTemplate ? '' : labelSxTrKey}
          preLabelSxTrKey={isNotTopTemplate || !isHappybetSite ? '' : labelSxGruppoTrKey}
          iconSrc={isHappybetSite ? iconSrc : undefined}
          labelDx={labelDx}
          labelDxTrKey={labelDxTrKey}
          tooltipText={
            infoTipoScommessaList[indexManifestazione]?.toolTip && infoTipoScommessaList[indexManifestazione]?.toolTip
          }
          tooltipTextTrKey={
            infoTipoScommessaList[indexManifestazione]?.toolTipTrKey &&
            infoTipoScommessaList[indexManifestazione]?.toolTipTrKey
          }
          tooltipPosition={isMobile ? TooltipPosition.BOTTOM_LEFT : TooltipPosition.BOTTOM}
          className={classNames({ [styles.hidden]: !isMobile })}
        />
        <SportTableScommesse
          title={manifestazione.descrizione}
          gruppo={isHappybetSite ? manifestazione.gruppo : undefined}
          iconSrc={isHappybetSite ? manifestazione.iconSrc : undefined}
          className={styles.noMargin}
          titleTrKey={manifestazione.descrizioneTrKey}
          avvenimenti={avvenimenti}
          gruppoTrKey={isHappybetSite ? manifestazione.gruppoTrKey : undefined}
          showTitle={!isNotTopTemplate}
          hasBorderSide
          isTopTemplate={!isNotTopTemplate}
          showTableTitle={!isMobile && isFirst}
          hasHeaderScommessa={isFirst}
          infoTipoScommessaKeyList={infoTipoScommessaKeyList}
          selectedIndexInfoTipoScommessa={infoTipoScommessaIndex}
          showOnlyBilanciata
        />
      </div>
    );
  },
  (prevProps, nextProps) =>
    prevProps.isFirst === nextProps.isFirst &&
    prevProps.isNotTopTemplate === nextProps.isNotTopTemplate &&
    prevProps.indexManifestazione === nextProps.indexManifestazione &&
    prevProps.infoTipoScommessaIndex === nextProps.infoTipoScommessaIndex &&
    shallowEqual(prevProps.avvenimenti, nextProps.avvenimenti) &&
    shallowEqual(prevProps.manifestazione, nextProps.manifestazione) &&
    shallowEqual(prevProps.infoTipoScommesseKeyListTab, nextProps.infoTipoScommesseKeyListTab)
);
